/**
 * @example
 * const EmotionComponent = styled('a')`
 *  ${helperListItemHover()};
 *  background-color: ${props => props.isActive && 'blue'};
 * `;
 * @example
 * const EmotionComponent = styled('a')`
 *   ${props =>
 *     helperListItemHover({
 *      hoverBgColor: '#ccc',    // Если нужно поменять цвет :hover и :focus
 *      activeBgColor: '#eee',   // Если нужно поменять цвет :active
 *      isActiveBgColor: '#ddd', // Если нужно поменять цвет активного состояния
 *      isActive: props.isActive // Если нужно добавить состояние активности
 *     })
 *   };
 * `;
 */

import { css } from '@emotion/react';
import { Colors } from '../common/Colors';
import { Variables } from '../common/Variables';

interface ListItemHoverProps {
  hoverBgColor?: string;
  activeBgColor?: string;
  isActiveBgColor?: string;
  isActive?: boolean;
}

export const helperListItemHover = (props?: ListItemHoverProps) => {
  const {
    hoverBgColor = Colors.ut.input,
    activeBgColor = Colors.ut.primaryDim,
    isActiveBgColor = Colors.ut.primaryDim,
    isActive
  } = props || ({} as ListItemHoverProps);

  return css`
    cursor: ${isActive && 'default'};
    background-color: ${isActive && isActiveBgColor};
    transition: background-color ${Variables.listTransitionDuration} ${Variables.listTimingFunction};

    ${!isActive &&
    css`
      cursor: pointer;

      &:focus {
        outline: 0;
      }

      &:hover,
      &:focus-visible {
        background-color: ${hoverBgColor};
        transition-duration: ${Variables.listTransitionDurationHover};
        transition-timing-function: ${Variables.listTimingFunctionHover};
      }

      &:active {
        background-color: ${activeBgColor};
      }
    `}
  `;
};
